import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { closeAddReclamationDialog } from 'store/common/commonActions';

import { genererPDF } from 'store/pieceGestion/pieceGestionActions';

import DefautProduitSAVAutoriseStep from './DefautProduitSAVAutoriseStep';

import dateHelper from 'utils/dateHelper';

import { Modeslivraison } from 'constants.js';
import { ReclamationQualificationDetailType } from 'constants.js';
import { ReclamationQualificationDetailCodes } from 'constants.js';
import { estPieceRapido } from 'utils/depotHelper';

class DefautProduitSAVAutoriseStepContainer extends React.Component {

    async componentDidMount() {

        const { reclamation, onDetailChange } = this.props;

        if (reclamation.numeroPiece !== '') {

            // On force l'ajout du détail achat initial 

            const qualificationDetails = [{
                code: ReclamationQualificationDetailCodes.AchatInitialFoussier,
                type: ReclamationQualificationDetailType.Booleen,
                libelle: "S'agit-il d'un achat initial chez Foussier ? (oui, depuis onglet information)",
                valeurBool: true
            }];


            onDetailChange(qualificationDetails, [{ key: ReclamationQualificationDetailCodes.Piece, errorMsg: 'Veuillez sélectionner une pièce.' }], [], true);

        }

    }

    handleGenererPDF = (numeroPiece) => {
        const { genererPDF, piecesGestion } = this.props;

        // Résoudre la clé technique (BL ou DT) pour l'appel API — fallback sur numeroPiece pour le legacy
        const piece = piecesGestion ? piecesGestion.find(p => p.numeroPiece === numeroPiece) : null;
        const cleApi = piece?.bonLivraisonGestionCle || piece?.demandeTransfertGestionCle || numeroPiece;

        var result = genererPDF(cleApi);

        return result;
    }


    render() {
        const props = { ...this.props, genererPDF: this.handleGenererPDF }

        return (
            <DefautProduitSAVAutoriseStep {...props}/>
        );
    }
}


const mapStateToProps = (state, ownProps) => {

    let rapido = false;
    let livraisonDirecte = false;
    let enlevementMagasin = false;
    let agePiece = -1;

    let adresseLivraison = null;
    let dateAchat = null;

    let colisLogistiques = [];

    let piece = state.pieceGestion[ownProps.namespace].piecesGestion ? state.pieceGestion[ownProps.namespace].piecesGestion.items.find(p => p.numeroPiece === ownProps.reclamation.numeroPiece) : null;

    if (piece) {
        rapido = estPieceRapido(piece);
        livraisonDirecte = piece.modeLivraison === Modeslivraison.LD;
        enlevementMagasin = piece.modeLivraison === Modeslivraison.IMM;

        agePiece = dateHelper.age(piece.dateLivraison);

        adresseLivraison = piece.adresseLivraison ? {
            ...piece.adresseLivraison,
            nom: piece.adresseLivraison.nomLivraison
        } : null;

        if (adresseLivraison) {
            delete adresseLivraison.nomLivraison;
        }
        dateAchat = new Date(piece.dateLivraison);

        colisLogistiques = state.colisLogistique.colisLogistiques.items;
    }

    let pieceGestionLignesLoaded = state.pieceGestionLigne.pieceGestionLignes && state.pieceGestionLigne.pieceGestionLignes.items.length > 0;


    return {
        rapido,
        livraisonDirecte,
        enlevementMagasin,
        agePiece,
        adresseLivraison,
        dateAchat,
        colisLogistiques,
        pieceGestionLignesLoaded,
        piecesGestion: state.pieceGestion[ownProps.namespace].piecesGestion.items
    };
};

const mapDispatchToProps = (dispatch) => ({
    genererPDF: (cle) => dispatch(genererPDF(cle)),
    closeAddReclamationDialog: () => dispatch(closeAddReclamationDialog()),
});


DefautProduitSAVAutoriseStepContainer.propTypes = {
    reclamation: PropTypes.object.isRequired,
    namespace: PropTypes.string.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(DefautProduitSAVAutoriseStepContainer);